'use client';

import { type ReactNode } from 'react';

import { Depop } from '@depop/web-thrift-ui/Icons/Depop';
import { Body, Display } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

type HeroImage = {
  src: string;
  alt: string;
};

export function Hero({
  desktopImage,
  mobileImage,
  badge,
  heading,
  description,
  children,
}: {
  desktopImage: HeroImage;
  mobileImage: HeroImage;
  badge?: ReactNode;
  heading: ReactNode;
  description: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className={styles.hero}>
      <div className={styles.layout}>
        <div className={styles.imageCollage}>
          <img
            className={styles.collageImageDesktop}
            src={desktopImage.src}
            alt={desktopImage.alt}
          />
          <img
            className={styles.collageImageMobile}
            src={mobileImage.src}
            alt={mobileImage.alt}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.badge}>
            {badge ?? <Depop aria-hidden="true" />}
          </div>
          <Display className={styles.heading}>{heading}</Display>
          <Body variant="md-regular" className={styles.description}>
            {description}
          </Body>
          {children}
        </div>
      </div>
    </section>
  );
}
